<template>
  <div>
    <div class="top-container">
      <div class="line text-center">
        <Button
          type="primary"
          icon="md-add"
          @click="editItem(new_item)"
        >
          添加
        </Button>
        <div class="search-input">
          <Input
            v-model="params.search"
            placeholder="请输入搜索关键字"
            @on-enter="doSearch"
          />
        </div>
        <Ajaxbtn
          ref="searchBtn"
          :url="query_item_path"
          :params="params"
          type="search"
          @before="beforeSearch"
          @done="handleData"
          @fail="handleFail"
        />
      </div>
    </div>
    <div class="line list-container">
      <Table
        :columns="item_columns"
        :data="items"
      />
    </div>
    <div
      v-show="page_info.total"
      class="line paginate-fix-bottom"
    >
      <Page
        show-total
        show-elevator
        :current="page_info.current"
        :total="page_info.total"
        :page-size="page_info.page_size"
        @on-change="pageChange"
      />
    </div>
    <Modal
      v-model="edit_config.modal"
      width="600"
      title="添加 / 编辑"
      ok-text="保存"
      :mask-closable="false"
      :loading="edit_config.loading"
      @on-ok="editOk"
    >
      <div class="line">
        <Form :model="edit_item">
          <FormItem
            label="规则名"
            :label-width="80"
          >
            <i-input
              v-model="edit_item.name"
              type="text"
              placeholder="名称..."
            />
          </FormItem>
          <FormItem
            label="所属人"
            :label-width="80"
          >
            <Select
              v-model="edit_item.customer_id"
              filterable
              remote
              :remote-method="getCustomers"
              :loading="search_customer"
            >
              <Option
                v-for="customer in customer_list"
                :key="customer.id"
                :value="customer.id"
              >
                {{ customer.account }}
              </Option>
            </Select>
          </FormItem>
          <FormItem label="添加触发规则">
            <div
              v-for="(executor, index) in edit_item.executors"
              :key="index"
            >
              <Select
                v-model="executor.model_name"
                filterable
                remote
                :remote-method="getModels"
                :loading="search_executor"
              >
                <Option
                  v-for="model_name in model_name_list"
                  :key="model_name"
                  :value="model_name"
                >
                  {{ model_name }}
                </Option>
              </Select>
              <Select v-model="executor.execute_type">
                <Option
                  v-for="type in execute_type_list"
                  :key="type.value"
                  :value="type.value"
                >
                  {{ type.name }}
                </Option>
              </Select>
              <i-input
                v-model="executor.priority"
                placeholder="触发优先级"
              />
            </div>
            <Button @click="addExecutor">
              添加规则
            </Button>
          </FormItem>
        </Form>
      </div>
    </Modal>
  </div>
</template>

<script :route="{path:'/rule/list',noChkout: true}">
  import BaseItem from '../mixins/base_item'
  export default {
    /* router_info_start */
    router_info: {
      path:'/rule/list',
      noChkout: true
    },
    /* router_info_end */

    mixins: [BaseItem],
    data() {
      return {
        customer_list: [],
        model_name_list: [],
        execute_type_list: [
          {
            value: 0,
            name: 'after_create_commit'
          },
          {
            value: 1,
            name: 'after_update_commit'
          },
          {
            value: 2,
            name: 'after_destroy_commit'
          }
        ],
        search_executor: false,
        search_customer: false,
        search_model_name: false,
        item_columns: [
          {
            title: '规则名',
            key: 'name'
          },
          {
            title: '所属人',
            render: (h, params) => {
              return h('div', params.customer.name)
            }
          },
          {
            title: '描述',
            key: 'desc'
          },
          {
            title: '操作',
            render: (h, params) => {
              const ret = [
                h('Button', {
                  props: {
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.editItem(params.row)
                    }
                  }
                }, '编辑'),
                h('Button', {
                  props: {
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.editRuleFlow(params.row)
                    }
                  }
                }, '编辑规则流程')
              ]
              return h('div', ret)
            }
          }
        ],
        new_item: {
          name: '',
          customer_id: '',
          desc: '',
          executors: []
        },
        query_item_path: this.$util.api.query_rule,
        update_item_path: this.$util.api.update_rule
      }
    },
    methods: {
      addExecutor() {
        const new_executor = {
          model_name: '',
          execute_type: 0,
          priority: 0
        }
        this.edit_item.executors.push(new_executor)
      },
      getCustomers(query) {
        if (query !== '') {
          this.search_customer = true
          this.$util.ajax.get(this.$util.api.query_customer_name, {
            params: {
              search: query
            }
          }).then(response => response.data).then(res => {
            this.search_customer = false
            this.customer_list = res.data
          })
        }
      },
      getModels(query) {
        if (query !== '') {
          this.search_model_name = true
          this.$util.ajax.get(this.$util.api.query_model_name, {
            params: {
              search: query
            }
          }).then(response => response.data).then(res => {
            this.search_model_name = false
            this.model_name_list = res.data
          })
        }
      },
    // editOk () {
    //   console.log('wefefe')
    //   this.$util.ajax.post(this.$util.api.update_rule).then(rule)
    // },
    // updateRule(rule){
    //   this.$util.insertOrUpdateArrayItem(this., travel_order, true);
    // },
    },
  }
</script>
